module.exports = __webpack_public_path__ + "img/border-top-left.cbfc7b4d.svg";